import React from 'react';
import fp from 'lodash/fp';
import clsx from 'clsx';

import {IconButton, makeStyles} from '@material-ui/core';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {format, parseISO} from 'date-fns/fp';
import {utcToZonedTime} from 'date-fns-tz';
import {Clear} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    filter: {
        display: 'flex',
        '& .MuiIconButton-root': {
            padding: 0,
        },
    },
    filterValue: {
        minWidth: theme.spacing(16),
    },
}));

export function DateFilter({column, filter, onChangeFilter, ...props}) {
    const classes = useStyles();
    const rawValue = fp.getOr(null, column.field, filter);
    let value = null;
    const filterProps = {format: 'MM/dd/yyyy', ...column.filterProps};
    const {timeZone} = filterProps;

    if (rawValue) {
        value = utcToZonedTime(fp.get('$gte.$date', rawValue), timeZone);
    }
    /*
     * 1948-09-11 should be interpreted as
     * 1948-09-10T20:000...Z -> 1948-09-11T19:59:...Z
     */

    const onChange = (date, value) => {
        if (date && !isNaN(date)) {
            const utcDateMs = Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
            );
            const utcDateEndMs = 24 * 60 * 60 * 1000 + utcDateMs;
            const begin = utcDateMs;
            const end = utcDateEndMs;
            onChangeFilter(column.field, {
                $gte: {$date: begin},
                $lt: {$date: end},
            });
        }
    };

    const handleClear = () => {
        onChangeFilter(column.field, null);
    };
    const containerClass = clsx(classes.filter, value && classes.filterValue);

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className={containerClass}>
                <KeyboardDatePicker
                    value={value}
                    onChange={onChange}
                    {...filterProps}
                    {...props}
                />
                {rawValue && (
                    <IconButton onClick={handleClear}>
                        <Clear />
                    </IconButton>
                )}
            </div>
        </MuiPickersUtilsProvider>
    );
}

export function DateEditor({value, onChange, column}) {
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div>
                <KeyboardDatePicker value={value} onChange={onChange} />
            </div>
        </MuiPickersUtilsProvider>
    );
}

export default function renderDate(row, column) {
    if (!row) return null;
    let value = this.field ? fp.get(this.field, row.data) : null;
    if (fp.isString(value)) {
        try {
            value = parseISO(value);
        } catch (e) {
            console.error('Error parsing date', value, e);
        }
    }
    if (fp.isDate(value)) {
        try {
            value = format('MM/dd/yyyy', value);
        } catch (e) {
            console.error('Error formatting date', value, e);
            value = value.toJSON();
        }
    }
    return value;
}
